module.exports = __webpack_public_path__ + "media/components/assets/icons/check/check_circle-6eb9e4e511719012a566a3e84e7ce919.svg";